/* tslint:disable */
// prettier-ignore
// ReSharper disable RedundantEmptyConstructor
// ReSharper disable InconsistentNaming
/*
 *
 * This file is automatically generated, all manual changes to this file will be lost.
 *
 * To regenerate this file use the 'entitygen' tool.
 *
 */
// ------ Enum members ------
export var BehandlerIdType;
(function (BehandlerIdType) {
    BehandlerIdType[BehandlerIdType["ingen"] = 0] = "ingen";
    BehandlerIdType[BehandlerIdType["hPRnumber"] = 1] = "hPRnumber";
    BehandlerIdType[BehandlerIdType["foedselnummer"] = 2] = "foedselnummer";
    BehandlerIdType[BehandlerIdType["pseudoId"] = 3] = "pseudoId";
})(BehandlerIdType || (BehandlerIdType = {}));
export var BehandlerInnsynType;
(function (BehandlerInnsynType) {
    BehandlerInnsynType[BehandlerInnsynType["ingen"] = 1] = "ingen";
    BehandlerInnsynType[BehandlerInnsynType["krever"] = 2] = "krever";
    BehandlerInnsynType[BehandlerInnsynType["tilbysIVerktoy"] = 3] = "tilbysIVerktoy";
})(BehandlerInnsynType || (BehandlerInnsynType = {}));
export var BemanningType;
(function (BemanningType) {
    BemanningType[BemanningType["frivillige"] = 1] = "frivillige";
    BemanningType[BemanningType["fagfolk"] = 2] = "fagfolk";
    BemanningType[BemanningType["fasteAnsatte"] = 3] = "fasteAnsatte";
    BemanningType[BemanningType["personMedTilsvarendeErfaring"] = 4] = "personMedTilsvarendeErfaring";
})(BemanningType || (BemanningType = {}));
export var CompareOperator;
(function (CompareOperator) {
    CompareOperator[CompareOperator["greaterThan"] = 1] = "greaterThan";
    CompareOperator[CompareOperator["lessThan"] = 2] = "lessThan";
})(CompareOperator || (CompareOperator = {}));
export var Dag;
(function (Dag) {
    Dag[Dag["mandag"] = 1] = "mandag";
    Dag[Dag["tirsdag"] = 2] = "tirsdag";
    Dag[Dag["onsdag"] = 3] = "onsdag";
    Dag[Dag["torsdag"] = 4] = "torsdag";
    Dag[Dag["fredag"] = 5] = "fredag";
    Dag[Dag["lordag"] = 6] = "lordag";
    Dag[Dag["sondag"] = 7] = "sondag";
})(Dag || (Dag = {}));
export var DagType;
(function (DagType) {
    DagType[DagType["mandag"] = 1] = "mandag";
    DagType[DagType["tirsdag"] = 2] = "tirsdag";
    DagType[DagType["onsdag"] = 3] = "onsdag";
    DagType[DagType["torsdag"] = 4] = "torsdag";
    DagType[DagType["fredag"] = 5] = "fredag";
    DagType[DagType["lordag"] = 6] = "lordag";
    DagType[DagType["sondag"] = 7] = "sondag";
})(DagType || (DagType = {}));
export var Dialogtjeneste;
(function (Dialogtjeneste) {
    Dialogtjeneste[Dialogtjeneste["fastlegekonsultasjon"] = 1] = "fastlegekonsultasjon";
    Dialogtjeneste[Dialogtjeneste["eKonsultasjon"] = 2] = "eKonsultasjon";
    Dialogtjeneste[Dialogtjeneste["reseptfornyelse"] = 3] = "reseptfornyelse";
    Dialogtjeneste[Dialogtjeneste["timebestillingKonsultasjon"] = 4] = "timebestillingKonsultasjon";
    Dialogtjeneste[Dialogtjeneste["eKontakt"] = 6] = "eKontakt";
    Dialogtjeneste[Dialogtjeneste["timebestillingKoronatest"] = 7] = "timebestillingKoronatest";
    Dialogtjeneste[Dialogtjeneste["timebestillingKoronavaksine"] = 8] = "timebestillingKoronavaksine";
    Dialogtjeneste[Dialogtjeneste["timebestillingInfluensavaksine"] = 9] = "timebestillingInfluensavaksine";
    Dialogtjeneste[Dialogtjeneste["timebestillingLabtime"] = 10] = "timebestillingLabtime";
})(Dialogtjeneste || (Dialogtjeneste = {}));
export var FagomradeType;
(function (FagomradeType) {
    FagomradeType[FagomradeType["psykiskHelse"] = 1] = "psykiskHelse";
    FagomradeType[FagomradeType["sykdomOgSkader"] = 2] = "sykdomOgSkader";
    FagomradeType[FagomradeType["livsstilOgTrening"] = 3] = "livsstilOgTrening";
    FagomradeType[FagomradeType["tankerOgFolelser"] = 4] = "tankerOgFolelser";
    FagomradeType[FagomradeType["graviditetOgFodsel"] = 5] = "graviditetOgFodsel";
    FagomradeType[FagomradeType["radOgTipsIHverdagen"] = 6] = "radOgTipsIHverdagen";
})(FagomradeType || (FagomradeType = {}));
export var FormalskategoriType;
(function (FormalskategoriType) {
    FormalskategoriType[FormalskategoriType["informasjon"] = 1] = "informasjon";
    FormalskategoriType[FormalskategoriType["l\u00E6ring"] = 2] = "l\u00E6ring";
    FormalskategoriType[FormalskategoriType["veiledning"] = 3] = "veiledning";
    FormalskategoriType[FormalskategoriType["behandling"] = 4] = "behandling";
    FormalskategoriType[FormalskategoriType["kartlegging"] = 5] = "kartlegging";
})(FormalskategoriType || (FormalskategoriType = {}));
export var GrafiskElementType;
(function (GrafiskElementType) {
    GrafiskElementType[GrafiskElementType["ikon"] = 1] = "ikon";
    GrafiskElementType[GrafiskElementType["bilde"] = 2] = "bilde";
})(GrafiskElementType || (GrafiskElementType = {}));
export var HelsepersonellrolleType;
(function (HelsepersonellrolleType) {
    HelsepersonellrolleType[HelsepersonellrolleType["lege"] = 1] = "lege";
    HelsepersonellrolleType[HelsepersonellrolleType["psykolog"] = 2] = "psykolog";
    HelsepersonellrolleType[HelsepersonellrolleType["tannlege"] = 3] = "tannlege";
    HelsepersonellrolleType[HelsepersonellrolleType["ergoFysioKiro"] = 4] = "ergoFysioKiro";
    HelsepersonellrolleType[HelsepersonellrolleType["vernepleier"] = 5] = "vernepleier";
    HelsepersonellrolleType[HelsepersonellrolleType["farmasoeyt"] = 6] = "farmasoeyt";
    HelsepersonellrolleType[HelsepersonellrolleType["sykepleier"] = 7] = "sykepleier";
    HelsepersonellrolleType[HelsepersonellrolleType["veterinaer"] = 8] = "veterinaer";
    HelsepersonellrolleType[HelsepersonellrolleType["oevrigHelsepersonell"] = 9] = "oevrigHelsepersonell";
    HelsepersonellrolleType[HelsepersonellrolleType["behandlerUtenHpr"] = 10] = "behandlerUtenHpr";
})(HelsepersonellrolleType || (HelsepersonellrolleType = {}));
export var HovedType;
(function (HovedType) {
    HovedType[HovedType["veiledningstjeneste"] = 1] = "veiledningstjeneste";
    HovedType[HovedType["laeringsressurs"] = 2] = "laeringsressurs";
    HovedType[HovedType["skjema"] = 3] = "skjema";
    HovedType[HovedType["triagering"] = 4] = "triagering";
})(HovedType || (HovedType = {}));
export var Innholdstype;
(function (Innholdstype) {
    Innholdstype[Innholdstype["video"] = 1] = "video";
    Innholdstype[Innholdstype["podcast"] = 2] = "podcast";
    Innholdstype[Innholdstype["informasjon"] = 3] = "informasjon";
    Innholdstype[Innholdstype["oppgaver"] = 4] = "oppgaver";
    Innholdstype[Innholdstype["spill"] = 5] = "spill";
    Innholdstype[Innholdstype["chat"] = 6] = "chat";
    Innholdstype[Innholdstype["forum"] = 7] = "forum";
    Innholdstype[Innholdstype["egenregistreringer"] = 8] = "egenregistreringer";
    Innholdstype[Innholdstype["maleverktoy"] = 9] = "maleverktoy";
    Innholdstype[Innholdstype["anbefalingerOgRad"] = 10] = "anbefalingerOgRad";
})(Innholdstype || (Innholdstype = {}));
export var KatalogType;
(function (KatalogType) {
    KatalogType[KatalogType["veiledningstjeneste"] = 1] = "veiledningstjeneste";
    KatalogType[KatalogType["laringsressurs"] = 2] = "laringsressurs";
    KatalogType[KatalogType["skjema"] = 3] = "skjema";
    KatalogType[KatalogType["kartleggingsverktoey"] = 4] = "kartleggingsverktoey";
})(KatalogType || (KatalogType = {}));
export var KodeverkType;
(function (KodeverkType) {
    KodeverkType[KodeverkType["iCD10"] = 1] = "iCD10";
    KodeverkType[KodeverkType["iPC2"] = 2] = "iPC2";
    KodeverkType[KodeverkType["mesh"] = 3] = "mesh";
    KodeverkType[KodeverkType["snomed"] = 4] = "snomed";
})(KodeverkType || (KodeverkType = {}));
export var LenkeType;
(function (LenkeType) {
    LenkeType[LenkeType["standard"] = 1] = "standard";
    LenkeType[LenkeType["nedlastingAppAndroid"] = 2] = "nedlastingAppAndroid";
    LenkeType[LenkeType["nedlastingAppIphone"] = 3] = "nedlastingAppIphone";
    LenkeType[LenkeType["utvidetInformasjon"] = 4] = "utvidetInformasjon";
    LenkeType[LenkeType["selvstendigVerktoyExternal"] = 50] = "selvstendigVerktoyExternal";
})(LenkeType || (LenkeType = {}));
export var MalgruppeType;
(function (MalgruppeType) {
    MalgruppeType[MalgruppeType["barn"] = 1] = "barn";
    MalgruppeType[MalgruppeType["ungdom"] = 2] = "ungdom";
    MalgruppeType[MalgruppeType["voksne"] = 3] = "voksne";
    MalgruppeType[MalgruppeType["eldre"] = 4] = "eldre";
})(MalgruppeType || (MalgruppeType = {}));
export var OppstartType;
(function (OppstartType) {
    OppstartType[OppstartType["ingen"] = 1] = "ingen";
    OppstartType[OppstartType["direkteLenke"] = 2] = "direkteLenke";
    OppstartType[OppstartType["skjema"] = 3] = "skjema";
    OppstartType[OppstartType["lTIv1_1"] = 4] = "lTIv1_1";
    OppstartType[OppstartType["oIDC"] = 5] = "oIDC";
})(OppstartType || (OppstartType = {}));
export var PameldingType;
(function (PameldingType) {
    PameldingType[PameldingType["forskrivning"] = 1] = "forskrivning";
    PameldingType[PameldingType["selvplukk"] = 2] = "selvplukk";
    PameldingType[PameldingType["plukkRepresentasjon"] = 3] = "plukkRepresentasjon";
    PameldingType[PameldingType["avvist"] = 4] = "avvist";
})(PameldingType || (PameldingType = {}));
export var RepresentasjonsforholdType;
(function (RepresentasjonsforholdType) {
    RepresentasjonsforholdType[RepresentasjonsforholdType["ukjent"] = 0] = "ukjent";
    RepresentasjonsforholdType[RepresentasjonsforholdType["segSelv"] = 1] = "segSelv";
    RepresentasjonsforholdType[RepresentasjonsforholdType["fullmakt"] = 2] = "fullmakt";
    RepresentasjonsforholdType[RepresentasjonsforholdType["foreldrerepresentasjon"] = 3] = "foreldrerepresentasjon";
})(RepresentasjonsforholdType || (RepresentasjonsforholdType = {}));
export var SkjemaTilgangType;
(function (SkjemaTilgangType) {
    SkjemaTilgangType[SkjemaTilgangType["standard"] = 1] = "standard";
    SkjemaTilgangType[SkjemaTilgangType["innbyggerOgEksternMottaker"] = 2] = "innbyggerOgEksternMottaker";
    SkjemaTilgangType[SkjemaTilgangType["kunEksternMottaker"] = 3] = "kunEksternMottaker";
})(SkjemaTilgangType || (SkjemaTilgangType = {}));
export var Sortering;
(function (Sortering) {
    Sortering[Sortering["publisertDato"] = 1] = "publisertDato";
    Sortering[Sortering["verktoyNavn"] = 2] = "verktoyNavn";
})(Sortering || (Sortering = {}));
export var SprakType;
(function (SprakType) {
    SprakType[SprakType["norskBokmal"] = 1] = "norskBokmal";
    SprakType[SprakType["norskNynorsk"] = 2] = "norskNynorsk";
    SprakType[SprakType["engelsk"] = 3] = "engelsk";
})(SprakType || (SprakType = {}));
export var StatusType;
(function (StatusType) {
    StatusType[StatusType["underArbeid"] = 1] = "underArbeid";
    StatusType[StatusType["publisert"] = 2] = "publisert";
    StatusType[StatusType["erstattetAvNyereVersjon"] = 3] = "erstattetAvNyereVersjon";
    StatusType[StatusType["trukketTilbake"] = 4] = "trukketTilbake";
})(StatusType || (StatusType = {}));
export var TilhorighetIdType;
(function (TilhorighetIdType) {
    TilhorighetIdType[TilhorighetIdType["ingen"] = 0] = "ingen";
    TilhorighetIdType[TilhorighetIdType["kommunenummer"] = 1] = "kommunenummer";
    TilhorighetIdType[TilhorighetIdType["organisasjonnummer"] = 2] = "organisasjonnummer";
    TilhorighetIdType[TilhorighetIdType["hERId"] = 3] = "hERId";
    TilhorighetIdType[TilhorighetIdType["rESHId"] = 4] = "rESHId";
})(TilhorighetIdType || (TilhorighetIdType = {}));
export var TjenesteomradeTypeId;
(function (TjenesteomradeTypeId) {
    TjenesteomradeTypeId[TjenesteomradeTypeId["helseregister"] = 1] = "helseregister";
    TjenesteomradeTypeId[TjenesteomradeTypeId["pasientjournal"] = 2] = "pasientjournal";
    TjenesteomradeTypeId[TjenesteomradeTypeId["helsehjelp"] = 3] = "helsehjelp";
    TjenesteomradeTypeId[TjenesteomradeTypeId["forvaltning"] = 4] = "forvaltning";
    TjenesteomradeTypeId[TjenesteomradeTypeId["sekundaerbruk"] = 5] = "sekundaerbruk";
})(TjenesteomradeTypeId || (TjenesteomradeTypeId = {}));
export var VeiledningskategoriType;
(function (VeiledningskategoriType) {
    VeiledningskategoriType[VeiledningskategoriType["noenASnakkeMed"] = 1] = "noenASnakkeMed";
    VeiledningskategoriType[VeiledningskategoriType["kroppOgHelse"] = 2] = "kroppOgHelse";
    VeiledningskategoriType[VeiledningskategoriType["psykiskHelseFoelelser"] = 3] = "psykiskHelseFoelelser";
    VeiledningskategoriType[VeiledningskategoriType["voldOvergrepOgTvang"] = 4] = "voldOvergrepOgTvang";
    VeiledningskategoriType[VeiledningskategoriType["mobbing"] = 5] = "mobbing";
    VeiledningskategoriType[VeiledningskategoriType["alkoholRusDoping"] = 6] = "alkoholRusDoping";
    VeiledningskategoriType[VeiledningskategoriType["rettigheterOgLovbrudd"] = 7] = "rettigheterOgLovbrudd";
    VeiledningskategoriType[VeiledningskategoriType["kjoennOgSeksualitet"] = 8] = "kjoennOgSeksualitet";
    VeiledningskategoriType[VeiledningskategoriType["skoleOgUtdanning"] = 9] = "skoleOgUtdanning";
    VeiledningskategoriType[VeiledningskategoriType["kranglingOgProblemerHjemme"] = 10] = "kranglingOgProblemerHjemme";
})(VeiledningskategoriType || (VeiledningskategoriType = {}));
export var VerktoyFormal;
(function (VerktoyFormal) {
    VerktoyFormal[VerktoyFormal["informasjon"] = 1] = "informasjon";
    VerktoyFormal[VerktoyFormal["laering"] = 2] = "laering";
    VerktoyFormal[VerktoyFormal["veiledning"] = 3] = "veiledning";
    VerktoyFormal[VerktoyFormal["behandling"] = 4] = "behandling";
    VerktoyFormal[VerktoyFormal["kartlegging"] = 5] = "kartlegging";
    VerktoyFormal[VerktoyFormal["sjekkpunkt"] = 6] = "sjekkpunkt";
    VerktoyFormal[VerktoyFormal["kontrollsporsmal"] = 7] = "kontrollsporsmal";
})(VerktoyFormal || (VerktoyFormal = {}));
export var VerktoyKategori;
(function (VerktoyKategori) {
    VerktoyKategori[VerktoyKategori["ingenBrukerprofil"] = 1] = "ingenBrukerprofil";
    VerktoyKategori[VerktoyKategori["lokalBrukerprofil"] = 2] = "lokalBrukerprofil";
    VerktoyKategori[VerktoyKategori["egenBrukerprofil"] = 3] = "egenBrukerprofil";
    VerktoyKategori[VerktoyKategori["sentralBrukerprofil"] = 4] = "sentralBrukerprofil";
    VerktoyKategori[VerktoyKategori["sentralPseudonymisertBrukerprofil"] = 5] = "sentralPseudonymisertBrukerprofil";
})(VerktoyKategori || (VerktoyKategori = {}));
export var VerktoyType;
(function (VerktoyType) {
    VerktoyType[VerktoyType["app"] = 1] = "app";
    VerktoyType[VerktoyType["weblosning"] = 2] = "weblosning";
})(VerktoyType || (VerktoyType = {}));
export var VerktoyType2;
(function (VerktoyType2) {
    VerktoyType2[VerktoyType2["kartleggingsverktoy"] = 1] = "kartleggingsverktoy";
    VerktoyType2[VerktoyType2["nettbasertKurs"] = 2] = "nettbasertKurs";
    VerktoyType2[VerktoyType2["chat"] = 3] = "chat";
    VerktoyType2[VerktoyType2["telefon"] = 4] = "telefon";
    VerktoyType2[VerktoyType2["video"] = 5] = "video";
    VerktoyType2[VerktoyType2["brosjyre"] = 6] = "brosjyre";
    VerktoyType2[VerktoyType2["podcast"] = 7] = "podcast";
})(VerktoyType2 || (VerktoyType2 = {}));
// ReSharper restore RedundantEmptyConstructor
// ReSharper restore InconsistentNaming
/* tslint:enable */ 
